export default __webpack_public_path__ + "static/media/lds-logo_sv.17766c6cda2604da.svg";